import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../../packages/kiti/components/presentation/Text'

const ModalHeader = () => {
  const { t } = useTranslation('availability')

  return (
    <>
      <Title size="h4" color={COLORS.dark2} noMargin>
        {t('statusSourceConfig.title')}
      </Title>
      <Separator weight={2} />

      <Text>{t('statusSourceConfig.description')}</Text>
      <Separator weight={4} />
    </>
  )
}

export default ModalHeader
